export default function NFormatterTest(value: any, type: any, symbol: any, commaSeparated = false) {
  const SI_SYMBOL = ['Unit', 'Lac', 'Cr'];

  const Rformatter = new Intl.NumberFormat('en-IN', {
    useGrouping: true,
    currency: 'INR',
  });

  const formatAmount = () => {
    if (symbol !== SI_SYMBOL[0]) {
      return parseFloat(`${Rformatter.format(value || 0)}`);
    }

    // A missing value formats as 0, like the other branches (`undefined <= n` is false).
    if (value == null || value <= 9999999) {
      return `${Rformatter.format(value || 0)}`;
    }

    if (!commaSeparated) {
      return value;
    }

    const nvalue = Rformatter.format(value.toFixed(2) || 0).replace('₹ ', '');
    const right = nvalue.substring(nvalue.length - 12);
    const left = nvalue.substring(0, nvalue.length - 12).replace(',', '');

    const newVal = (left ? left + ',' : '') + right;
    return newVal.replace(',,', ',');
  };

  const formatNumber = () => {
    if (!commaSeparated) {
      return parseInt(value);
    }

    const Nformatter = new Intl.NumberFormat('en-IN');
    return Nformatter.format(Math.round(value));
  };

  const formatPercentage = () => {
    return `${value}%`;
  };

  switch (type) {
    case 'amount':
    case 'Amount':
      return formatAmount();

    case 'number':
    case 'Number':
      return formatNumber();

    case 'percentage':
      return formatPercentage();

    default:
      return value;
  }
}
